import React, { useState } from 'react';
import './CreateOrgAndAdmin.css';

const DENTAL_API_URL = 'https://dentalexpressserver.azurewebsites.net';

const CreateOrgAndAdmin = () => {
  const [email, setEmail] = useState('');
  const [orgName, setOrgName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [registrationUrl, setRegistrationUrl] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !orgName) {
      setError('Both email and organization name are required');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Get JWT token from localStorage
      const token = localStorage.getItem('jwtToken');
      const headers = {
        'Content-Type': 'application/json',
      };
      
      // Add Authorization header if token exists
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch(`${DENTAL_API_URL}/api/create-org-and-admin`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          email,
          orgName
        })
      });

      // Handle 401 (unauthorized) response
      if (response.status === 401) {
        // Token is invalid or expired, clear it and reload
        localStorage.removeItem('jwtToken');
        window.location.reload();
        throw new Error('Session expired, please log in again.');
      }

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Failed to create organization and send admin invitation' }));
        throw new Error(errorData.message || 'Failed to create organization and send admin invitation');
      }

      const data = await response.json();
      
      setSuccess(`✅ Organization "${data.orgName}" created successfully! (ID: ${data.organizationId})`);
      setRegistrationUrl(data.registrationUrl);
      setEmail('');
      setOrgName('');
      
      console.log('Organization created:', data);
    } catch (err) {
      console.error('Error creating org and admin:', err);
      setError(err.message || 'Failed to create organization and admin');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-org-container">
      <h2 className="create-org-title">Create Organization & Admin</h2>
      <p className="create-org-description">
        Create a new organization and send an admin invitation link
      </p>

      <form onSubmit={handleSubmit} className="create-org-form">
        <div className="form-group">
          <label htmlFor="orgName" className="form-label">
            Organization Name
          </label>
          <input
            id="orgName"
            type="text"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            placeholder="e.g., Perfect Dental Management"
            className="form-input"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email" className="form-label">
            Admin Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@example.com"
            className="form-input"
            disabled={loading}
          />
        </div>

        {error && (
          <div className="alert alert-error">
            ❌ {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            {success}
          </div>
        )}

        {registrationUrl && (
          <div className="registration-link-box">
            <strong>Admin Registration Link:</strong>
            <div className="link-display">
              <input
                type="text"
                value={registrationUrl}
                readOnly
                className="link-input"
              />
              <button
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(registrationUrl);
                  alert('Link copied to clipboard!');
                }}
                className="copy-button"
              >
                Copy
              </button>
            </div>
          </div>
        )}

        <button
          type="submit"
          disabled={loading || !email || !orgName}
          className="submit-button"
        >
          {loading ? 'Creating...' : 'Create Organization & Get Link'}
        </button>
      </form>

      <div className="info-box">
        <strong>What happens:</strong>
        <ul>
          <li>✅ Organization document created with ID: org-[timestamp]</li>
          <li>🔗 Registration link generated (NO email sent - copy link manually)</li>
          <li>📝 Admin registers → creates user with practiceId: "groupAdminOnboarding"</li>
          <li>✍️ Admin signs BAA on special onboarding page</li>
          <li>🏢 Admin practice created: {`{orgId}admin`} (e.g., "PDMadmin")</li>
          <li>🎯 Admin redirected to /recall-analysis dashboard</li>
        </ul>
      </div>
    </div>
  );
};

export default CreateOrgAndAdmin;

